import { API_AUTH } from "./common";

const CamDoApi = {
  getChiTietHopDong: ({ choVayId }) =>
    API_AUTH.get(`quan-ly-cho-vay/chi-tiet?id=${choVayId}`, {}),

  getChiTietHopDong1: (choVayId, dbName) =>
    API_AUTH.get(`quan-ly-cho-vay/chi-tiet1?id=${choVayId}&dbName=${dbName || ''}`, {}),

    
  getChiTietHopDong2: (choVayId) =>
    API_AUTH.get(`quan-ly-cho-vay/chi-tiet2?id=${choVayId}`, {}),

  getChiTietCamDo: (choVayId) =>
    API_AUTH.get(`quan-ly-cho-vay/chi-tiet-cam-do?id=${choVayId}`, {}),

  getLichSuHopDong: ({ choVayId, pageIndex, pageSize, dbName }) =>
    API_AUTH.get(
      `quan-ly-cho-vay/lich-su?chovayId=${choVayId}&pageIndex=${pageIndex}&pageSize=${pageSize}&dbName=${dbName || ''}`,
      {}
    ),
  getLichSuVayThemTraBotGoc: ({ choVayId, dbName }) =>
    API_AUTH.get(
      `quan-ly-cho-vay/lich-su-vay-them-tra-bot-goc?chovayId=${choVayId}&dbName=${dbName || ''}`,
      {}
    ),
  getListTaiSanCamCo: ({ choVayId, dbName }) =>
    API_AUTH.get(`quan-ly-cho-vay/tai-san-cam-co?chovayId=${choVayId}&dbName=${dbName || ''}`, {}),
  
  getListTaiSanCamCo1: (choVayId, dbName) =>
    API_AUTH.get(`quan-ly-cho-vay/tai-san-cam-co?chovayId=${choVayId}&dbName=${dbName || ''}`, {}),
  getLichSuNoPhaiThu: ({ choVayId, pageIndex, pageSize, dbName }) =>
    API_AUTH.get(
      `quan-ly-cho-vay/lich-su-no-phai-thu?chovayId=${choVayId}&pageIndex=${pageIndex}&pageSize=${pageSize}&dbName=${dbName || ''}`,
      {}
    ),
  getListGhiChu: ({ choVayId, pageIndex, pageSize, dbName }) =>
    API_AUTH.get(
      `quan-ly-cho-vay/ghi-chu?chovayId=${choVayId}&pageIndex=${pageIndex}&pageSize=${pageSize}&dbName=${dbName || ''}`,
      {}
    ),
  chiTietCacLoaiPhiHopDong: (chovayId, typeChoVay, dbName) =>
    API_AUTH.get(
      `quan-ly-cho-vay/phi-hang-ky-cho-vay-theo-cho-vay?chovayId=${chovayId}&typeChoVay=${typeChoVay}&dbName=${dbName || ''}`,
      {}
    ),
  chiTietCacLoaiPhiHopDong1: (chovayId, typeChoVay, dbName) =>
    API_AUTH.get(
      `quan-ly-cho-vay/phi-cho-vay-theo-cho-vay?chovayId=${chovayId}&typeChoVay=${typeChoVay}&dbName=${dbName || ''}`,
      {}
    ),

  getChiTietHopDong: (choVayId, type) =>
    API_AUTH.get(`quan-ly-cho-vay/chi-tiet-hop-dong?id=${choVayId}&type=${type}`, {}),

  // Nguồn khách hàng / Nghề nghiệp / Khu vực / Hình thức vay của hợp đồng (isMoney88)
  thuocTinhThongKeHopDong: (chovayId, dbName) =>
    API_AUTH.get(
      `quanlychovay/thuoc-tinh-thong-ke-hop-dong?chovayId=${chovayId}&dbName=${dbName || ''}`,
      {}
    ),
};

export default CamDoApi;
